const ACTIVE = 'ACTIVE'
const INACTIVE = 'INACTIVE'

const userCompanies = {
  ACTIVE,
  INACTIVE,
}

export default userCompanies
